var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('b-table',{attrs:{"data":_vm.form}},[_vm._t("default")],2),_c('b-button',{attrs:{"type":"is-primary"},on:{"click":function($event){_vm.$emit('update', {
                key: _vm.configKey,
                data: JSON.stringify(_vm.form),
                type: 'table'
            })}}},[_vm._v(" Modifier ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }